/**
 * Which product you're in. Not to be confused with a storefront, which is one shef's page at
 * `tablerun.com/tr/<slug>` — these were the same word until 2026-08-11.
 */
export enum Brand {
  Shef = 'shef',
  TableRun = 'tablerun',
}

const BRAND_VALUES: ReadonlySet<string> = new Set(Object.values(Brand));

function isBrand(value: unknown): value is Brand {
  return typeof value === 'string' && BRAND_VALUES.has(value);
}

/** Unknown or absent values fall back to Shef, so brand-awareness stays purely additive. */
export function parseBrand(raw: unknown): Brand {
  return isBrand(raw) ? raw : Brand.Shef;
}

const BRAND_DISPLAY_NAMES: Record<Brand, string> = {
  [Brand.Shef]: 'Shef',
  [Brand.TableRun]: 'TableRun',
};

/** Human-facing brand name (e.g. for statement descriptors, copy). */
export function brandDisplayName(brand: Brand): string {
  return BRAND_DISPLAY_NAMES[brand];
}
